<template>
  <div class="container" ref="subscribe" data-aos="appear">
    <div class="disabled">
      <div class="col top bar-glow">
        <div class="bar left"></div>
        <div class="title text-glow">Subscribe</div>
        <div class="bar right"></div>
      </div>
      <div class="col middle">
        <div class="bar left bar-glow"></div>
        <sign-up-form class="signup" />
        <div class="bar right bar-glow"></div>
      </div>
      <div class="col bottom bar-glow">
        <div class="bar left"></div>
        <div class="bar right"></div>
      </div>
    </div>
    <text-typer class="warning" :text="`[WARNING] Email service disabled due to invalid project status: <HIATUS>     `" />
  </div>
</template>

<script>
import SignUpForm from "./sign-up-form"
import TextTyper from '../components/text-typer'
export default {
  components: {
    SignUpForm,
    TextTyper
  }
}
</script>

<style scoped lang="scss">
@import "@/views/project-synthecite/styles/variables.scss";

$barThickness: 5px;
$transition: 1s all;

.container {
  margin-left: auto;
  margin-right: auto;
  width: 60%;
  display: flex;
  flex-direction: column;
  transition: $transition;

  .disabled {
    filter: blur(3px);
    pointer-events: none;
    user-select: none;
  }
  
}

@media only screen and (max-width: 900px) {
  .container {
    width: 100%;
  }
}
.col {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.top {
  align-items: center;
}
.top,
.bottom {
  .bar {
    height: $barThickness;
    width: 100%;
  }
}
.middle {
  margin-top: -28px;
  .bar {
    width: $barThickness;
    height: auto;
  }
}

.bar {
  background-color: rgba($green, 0.4);
}

/* AOS Bar animations */

$visBarTransLength: 0.2s;
$hidBarTransLength: 0.1s;

[data-aos="appear"] {
  &.container {
    opacity: 0;
  }
  .bar {
    transition: $hidBarTransLength all;
  }
  .col {
    &.top .bar {
      transition-delay: calc(2 * #{$hidBarTransLength});
    }
    &.col.middle .bar {
      transition-delay: $hidBarTransLength;
    }
    &.bottom .bar {
      transition-delay: 0s;
    }
  }
  .top .right,
  .bottom .left {
    clip-path: polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%);
  }
  .top .left,
  .bottom .right {
    clip-path: polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%);
  }
  .left,
  .right {
    clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%);
  }
  &.aos-animate {
    &.container {
      opacity: 1;
    }
    .bar {
      transition: $visBarTransLength all;
      transition-timing-function: linear;
      clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
    }
    .col {
      &.top .bar {
        transition-delay: 0s;
      }
      &.col.middle .bar {
        transition-delay: $visBarTransLength;
      }
      &.bottom .bar {
        transition-delay: calc(2 * #{$visBarTransLength});
      }
    }
    .bottom {
      .left,
      .right {
        transition-timing-function: ease;
        transition-duration: calc(2 * #{$visBarTransLength});
      }
    }
  }
}

.title {
  font-size: 60px;
  margin-right: 20px;
  margin-left: 20px;
}

.signup {
  margin-bottom: 40px;
  margin-top: 40px;
  width: 80%;
}
.warning { 
  color: $warning-text-color;
  font-size: 20px;
  margin-top: 20px;

}
</style>